/* global document, global window */

import config from './webpack/config';


if (config.analytics) {
	window.GoogleAnalyticsObject = 'ga';
	window.ga = window.ga || ((...args) => {
		(window.ga.q = window.ga.q || []).push(args);
	});
	window.ga.l = 1 * new Date();
	window.ga('create', config.analytics, 'auto');
	window.ga('send', 'pageview');

	const gaScript = document.createElement('script');
	const firstScript = document.getElementsByTagName('script')[0];
	gaScript.async = 1;
	gaScript.src = 'https://www.google-analytics.com/analytics.js';
	firstScript.parentNode.insertBefore(gaScript, firstScript);
}



// WEBPACK FOOTER //
// ./js/analytics.js